<template>
    <div>
    <Loader />
    <div v-if="loading==false" class="container-fluid" style="height:100%">

            <b-row class="sidebar-title">
                <b-col sm="12" class="p-2">
                    <img alt="" class="img-fluid float-right" src="/img/logo_beghelli_white.png" width="100px">       
                </b-col>
           
                <b-col md="6" sm="12" class="p-2">
                    <span> {{$t('page_product.products')}} </span> |
                    <span v-if="!isLighting"> {{$t('page_product.emergency_device')}} </span>
                    <span v-if="isLighting"> {{$t('page_product.lighting_device')}} </span>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12" class="pt-3 pb-2">
                    <h4>{{this.currentProduct.product_desc}}</h4>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12" v-if="this.currentProduct.product_image!=null && this.currentProduct.product_image!='undefined' && this.currentProduct.product_image!=''">
                    <img alt="" class="img-fluid" :src="this.pathDeviceImages+this.currentProduct.product_image">       
                </b-col>

                <b-col md="6" sm="12" class="pl-2 pb-1">
                    <h6 class="typo-display-small pt-3 pl-3 mt-3">{{$t('page_product.product_detail')}}</h6>
                    <h5><span class="typo-product p-3">{{$t('details_lamp.lamp_code')}}:</span> {{this.currentProduct.product_code}}</h5>
                    <h5><span class="typo-product p-3">{{$t('details_lamp.lamp_order_code')}}:</span> {{this.currentProduct.order_code}}</h5>
                    <h5 v-if="this.productLogicaId!=null && this.productLogicaId!='0000' && this.productType!='FM' && this.productType!='AC' && !isCu"><span class="typo-product p-3">{{$t('page_product.logica_id')}}:</span> {{this.productLogicaId}}</h5>
                    <h5 v-if="this.productLogicaId!=null && isCu"><span class="typo-product p-3">Serial ID:</span> {{this.productLogicaId}}</h5>
                    <h5 v-if="this.productLogicaId!=null && this.productType=='FM'"><span class="typo-product p-3">Radio ID:</span> {{this.productLogicaId}}</h5>
                    <h5 v-if="this.productSn!=null"><span class="typo-product p-3">{{$t('page_product.serial')}}:</span> {{this.productSn}}</h5>
                    <div class="pt-3"></div>
                    <h5 v-if="!isCu && this.productType!='FM' && this.productType!='AC' && this.productType!='HT' && !isLighting && !isSicuro"><span class="typo-product p-3">{{$t('page_product.autonomy_settings')}}:</span> {{this.currentProduct.autonomy_settings}}H</h5>
                    <span><a v-if="this.productIdSw!='0' && !isDali && !isSicuro" href="https://play.google.com/store/apps/details?id=it.beghelli.cablecom.connect&hl=it&gl=US" target="_blank"><img alt="" class="ml-3 img-fluid" src="img/Bconnect.png" width='50px'></a></span> 
                    <span><a v-if="this.productIdSw!='0' && !isDali" href="https://nube.beghelli.it" target="_blank"><img alt="" class="ml-3 img-fluid" src="img/favicon.png" width='50px'></a></span>
                    <span v-if="this.currentProduct.Bluetooth=='Y'"><img alt="" class="ml-3 img-fluid" src="img/bluetooth.png" width='105px'></span>
                    <div class="pt-3"></div>
                    
                    <!-- Battery Info -->
                    <div v-if="this.productType!='FM' && this.productType!='AC' && !isLighting && this.productType!='HT' && !isSicuro && !isGateway">
                        <hr>
                        <h6 class="typo-display-small pt-3 pl-3">{{$t('page_product.battery')}}</h6>
                        <h5><span class="typo-product p-4"><i class="fa fa-battery fa-1x" style="color:#008BC7"></i></span> {{this.currentProduct.battery_desc}}</h5>
                        <h5><span class="typo-title p-3">{{$t('details_lamp.battery_code')}}:</span> {{this.currentProduct.battery_code}}</h5>
                    </div>
                    
                    <div v-if="this.productType!='FM' && this.productType!='AC' && !isLighting" class="pt-3"></div>
                    <hr>

                    <!-- Technical Info -->
                    <p class="typo-display-small pt-3 pl-3">{{$t('page_product.device_info')}}</p>
                    <p class="pl-3 typo-tech" v-if="this.productIdSw!=null && this.productIdSw!='0' && !isDali && !isSicuro">Firmware: {{this.productIdSw}}.{{this.productRelSw}}</p>
                    <p class="pl-3 typo-tech" v-if="this.productIdSw!=null && this.productIdSw!='0' && isSicuro">Firmware: {{this.productIdSw}}</p>
                    <p class="pl-3 typo-tech" v-if="this.productIdSw!=null && this.productBuild!='0' && !isDali">Build: {{this.productBuild}}</p>
                    <p class="pl-3 typo-tech" v-if="isDali">GTIN: {{this.productGTIN}}</p>
                    <p class="pl-3 typo-tech">Product date: {{this.productDate}}</p>
                    <p class="pl-3 typo-tech">Product plant: {{this.productPlant}}</p>
                    <p class="pl-3 typo-tech" v-if="this.currentProduct['29x_code']!=null">Electronic part: {{this.currentProduct['29x_code']}}</p>
                               
                    <!-- Dali2 certificated product and driver -->
                    <p v-if="this.currentProduct['233_code']=='233079101'" class="pl-3 typo-tech"><a style="color:black;" target="_blank" href="https://www.dali-alliance.org/products/7708/modulo-dali-15058"><img src="img/dali-2.png" height="25px" class="pr-3"> Emergency driver {{ this.currentProduct['233_code'] }} with accessory 15058</a></p>
                    <p v-if="this.currentProduct['233_code']=='233079301'" class="pl-3 typo-tech"><a style="color:black;" target="_blank" href="https://www.dali-alliance.org/products/7708/modulo-dali-15058"><img src="img/dali-2.png" height="25px" class="pr-3"> Emergency driver {{ this.currentProduct['233_code'] }} with accessory 15058</a></p>
                    <p v-if="this.currentProduct['233_code']=='233106001'" class="pl-3 typo-tech"><a style="color:black;" target="_blank" href="https://www.dali-alliance.org/products/7708/modulo-dali-15058"><img src="img/dali-2.png" height="25px" class="pr-3"> Emergency driver {{ this.currentProduct['233_code'] }} with accessory 15058</a></p>
                    <p v-if="this.currentProduct['233_code']=='233108001'" class="pl-3 typo-tech"><a style="color:black;" target="_blank" href="https://www.dali-alliance.org/products/8985/inverter-universale-ct-1939915080"><img src="img/dali-2.png" height="25px" class="pr-3"> Emergency driver {{ this.currentProduct.order_code }} with accessory 15080</a></p>
                    <p v-if="this.currentProduct['233_code']=='233173200'" class="pl-3 typo-tech"><a style="color:black;" target="_blank" href="https://www.dali-alliance.org/products/10767/slim-emergency-driver-233173200"><img src="img/dali-2.png" height="25px" class="pr-3"> Emergency driver {{ this.currentProduct['233_code'] }} with accessory 15080</a></p>
                    <p v-if="this.currentProduct['233_code']=='233133201'" class="pl-3 typo-tech"><a style="color:black;" target="_blank" href="https://www.dali-alliance.org/products/11131/ct-sa-emergency-driver-23313320115080"><img src="img/dali-2.png" height="25px" class="pr-3"> Emergency driver {{ this.currentProduct['233_code'] }} with accessory 15080</a></p>
                    <div class="pt-2"></div>
                    <hr>
                    
                    <!-- Pdf Manuals -->
                    <div v-if="this.currentProduct.product_pdf!=null && this.currentProduct.product_pdf!='undefined' && this.currentProduct.product_pdf!=''">
                        <h6 class="typo-display-small pt-3 pl-3" >{{$t('page_product.manuals')}}</h6>
                        <h6 class="typo-product p-4" v-if="this.currentProduct.product_pdf!=null && this.currentProduct.product_pdf!='undefined' && this.currentProduct.product_pdf!='' && !this.currentProduct.product_pdf.includes('|')"> 
                            <a :href="pathDevicePdf+this.currentProduct.product_pdf" target="_blank">
                                <span class="mr-1"><i class="fa fa-file"></i></span>
                                <span class="typo-product">{{this.currentProduct.product_pdf}} </span>
                            </a>                       
                        </h6>   

                        <div  v-if="this.currentProduct.product_pdf!=null && this.currentProduct.product_pdf!='undefined' && this.currentProduct.product_pdf!='' && this.currentProduct.product_pdf.includes('|')">
                                
                                <h6 class="typo-product p-1 pl-4">
                                <a :href="pathDevicePdf+this.currentProduct.product_pdf.split('|')[0]" target="_blank">
                                    <span class="mr-1"><i class="fa fa-file"></i></span>
                                    <span class="typo-product">{{this.currentProduct.product_pdf.split('|')[0]}} </span>
                                </a>    
                                </h6>

                                <h6 class="typo-product p-1 pl-4">
                                <a :href="pathDevicePdf+this.currentProduct.product_pdf.split('|')[1]" target="_blank">
                                    <span class="mr-1"><i class="fa fa-file"></i></span>
                                    <span class="typo-product">{{this.currentProduct.product_pdf.split('|')[1]}} </span>
                                </a>
                                </h6>    
                        </div>                    
                        <hr>
                    </div>

                    <!-- Video -->
                    <h6 v-if="this.currentProduct.product_desc.toUpperCase().includes('MODULA') || this.currentProduct.product_desc.toUpperCase().includes('CENTRALE')" class="typo-display-small pt-3 pl-3">{{$t('page_product.video')}}</h6>
                    <h6 class="typo-product pl-4"> 
                    <a v-if="this.currentProduct.product_desc.toUpperCase().includes('MODULA')" href="https://youtu.be/Yj2Oqe3L9uk" target="_blank">
                        <br><span class="mr-1"><i class="fa fa-youtube"></i></span>
                        <span class="typo-product">Modula Beghelli</span>
                    </a>
                    <a v-if="this.currentProduct.product_desc.toUpperCase().includes('CENTRALE')" href="https://youtu.be/sGoKnRF2LP8" target="_blank">
                        <br><span class="mr-1"><i class="fa fa-youtube"></i></span>
                        <span class="typo-product">B. Connect - Connessione con la centrale e configurazione impianto</span>
                    </a>
                    <a v-if="this.currentProduct.product_desc.toUpperCase().includes('CENTRALE')" href="https://youtu.be/wbUYZrinZe8" target="_blank">
                        <br><br><span class="mr-1"><i class="fa fa-youtube"></i></span>
                        <span class="typo-product">B. Connect - Configurazione test automatici e consultazione Logbook</span>
                    </a>
                    <a v-if="this.currentProduct.product_desc.toUpperCase().includes('CENTRALE')" href="https://youtu.be/wazz78GHeSI" target="_blank">
                        <br><br><span class="mr-1"><i class="fa fa-youtube"></i></span>
                        <span class="typo-product">B.Connect - Connessione della centrale al cloud NuBe Beghelli</span><br><br>
                    </a>
                    </h6>
                </b-col>
            </b-row>

            <b-row>
                <b-col >

                </b-col>
            </b-row>    

    </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: 'ProductPage',
    components: {
        Event
    },
    props: ['pid'],
    data() {
        return {
            productId:null,
            currentProduct:null,
            productLogicaId:null,
            productSn:null,  
            progressiveSn:null,
            qrChk:null,
            productSys:null,         
            productDate:null,
            productIdSw:null,
            productRelSw:null,
            productBuild:null,
            productGTIN:null,
            productPlant:null,
            productType:null,
            pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
            pathDevicePdf:process.env.VUE_APP_PATH_DEVICE_PDF,                        //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
        }
    },
    watch: {
        loading(val,oldval) {
             if (val==false)
             {
                this.currentProduct = this.$store.state.singleProductInfo;
                
                //create serial number and add chk if present only progrssive SN
                if(this.progressiveSn!=null)
                {
                    var headerSnHex=parseInt(this.currentProduct.product_code).toString(16).padStart(8,"0").toUpperCase();
                    var qrSerNum=this.hexToBytes(headerSnHex+this.progressiveSn);
                    console.log("Header SN:",headerSnHex);
                    console.log("Progressive SN:",this.progressiveSn);
                    var chkSn=new Uint8Array(1)
                    for(var j=0;j<qrSerNum.length; j++)
                    {
                        chkSn[0]=chkSn[0] ^ qrSerNum[j];
                    }
                    this.productSn=""+headerSnHex+this.progressiveSn+ chkSn[0].toString(16).toUpperCase();
         
                } 
            }
        }
     },
    computed:{
    ...mapState(['loading']),
    isLighting()
    {
        if(this.currentProduct.uuid.startsWith('DA') || this.currentProduct.uuid.startsWith('SB') || this.currentProduct.uuid.startsWith('RD'))
            return true;
        else
            return false;    
    },
    isDali()
    {
        if(this.currentProduct.uuid.startsWith('DA'))
            return true;
        else
            return false;    
    },
    isSicuro()
    {
        if(this.currentProduct.uuid.startsWith('SI') || this.currentProduct.uuid=="F005")
            return true;
        else
            return false;    
    },
    isGateway()
    {
        if(this.currentProduct.uuid=="F006" || this.currentProduct.uuid=="F007" || this.currentProduct.uuid=="F008")
            return true;
        else
            return false;    
    },
    isCu()
    {
        if(this.currentProduct.uuid=="F001" || this.currentProduct.uuid=="F002" || this.currentProduct.uuid=="F003" || this.currentProduct.uuid=="F004" || this.currentProduct.uuid=="F005" ||this.currentProduct.uuid=="F006" || this.currentProduct.uuid=="F007" || this.currentProduct.uuid=="F008")
            return true;
        else
            return false;    
    }

     },
     methods: {
      
        hexToBytes(hex) {
            for (var bytes = [], c = 0; c < hex.length; c += 2)
                bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },

        getProductDate(days)
        {
            var prodDate= new Date(2022,0,1);       //Data base di partenza 01/01/022 , i mesi vanno da 0 a 11
            prodDate.setDate(prodDate.getDate() + days);
            return prodDate;
        }          
      
    },
    mounted() {
        this.productId = this.$route.params.productId;
        console.log("Codice prodotto caricato: " +  this.productId);       

        var qrByte;
        var chk;
        var j;
        var daysAfter1122;


        //------------------- LENGTH == 26 -------------------------------
        //-- Si tratta di QR CODE di lampada length=26 senza serial number 
        //----------------------------------------------------------------- 

        if (this.productId != null && this.productId.length == 26) {
           
           //bisogna decodificare il prodotto
            let origCode = ""+this.productId;
            if (origCode.substr(0, 4) == "00AT" || origCode.substr(0, 4) == "00TR" || origCode.substr(0, 4) == "00TP")
            {
                this.productId = origCode.substr(2,2) + "-" + origCode.substr(4,4);
            } else {
                this.productId = "CT-" + origCode.substr(4,4);
                this.productLogicaId=origCode.substr(0,4);
            } 
            this.productDate=parseInt(origCode.substr(8,2),16) + "/" + (parseInt(origCode.substr(10,2),16)+"").padStart(2,"0") + "/" + "20"+parseInt(origCode.substr(12,2),16);
            this.productIdSw=""+parseInt(origCode.substr(15,3),16);
            this.productRelSw=""+parseInt(origCode.substr(14,1),16);
            this.productBuild=""+parseInt(origCode.substr(18,4),16);
            this.productPlant=""+parseInt(origCode.substr(22,2),16);
            console.log("productLogicaId: "+this.productLogicaId +" productDate:",this.productDate," productPlant:",this.productPlant," productIdSw:",this.productIdSw," productRelSw:",this.productRelSw," productBuild:",this.productBuild);
        }


        //------------------- LENGTH == 28 -------------------------------
        //-- Si tratta di QR CODE di lampada length=28 senza serial number 
        //----------------------------------------------------------------- 
        if (this.productId != null && this.productId.length == 28) {

            let origCode = ""+this.productId;
            this.productId = origCode.substr(6,4)
            this.productLogicaId=origCode.substr(0,6)
            this.productDate=parseInt(origCode.substr(14,2),16) + "/" + (parseInt(origCode.substr(12,2),16)+"").padStart(2,"0") + "/" + "20"+parseInt(origCode.substr(10,2),16);
            this.productIdSw=""+parseInt(origCode.substr(17,3),16);
            this.productRelSw=""+parseInt(origCode.substr(16,1),16);
            this.productBuild=""+parseInt(origCode.substr(20,4),16);
            this.productPlant=""+parseInt(origCode.substr(24,2),16);
            this.productType="cent";
            console.log("productLogicaId: "+this.productLogicaId +" productDate:",this.productDate," productPlant:",this.productPlant," productIdSw:",this.productIdSw," productRelSw:",this.productRelSw," productBuild:",this.productBuild);
        }


        //------------------- LENGTH == 44 -----------------------------------------------------------------------------------
        //-- Si tratta di QR CODE di lampada length=44 e Serial Number completo con header prodotto davanti al SN Progressivo
        //--------------------------------------------------------------------------------------------------------------------
         if (this.productId != null && this.productId.length == 44) {

            //get all qr code data
            let origCode = ""+this.productId;

            //controllo checksum qrcode
            var sysByte="00";
            if (origCode.substr(40,2)=="TR")
                sysByte="01";
            if (origCode.substr(40,2)=="AT")
                sysByte="02";
            if (origCode.substr(40,2)=="CT")
                sysByte="03";
            if (origCode.substr(40,2)=="HT")
                sysByte="03";    
            if (origCode.substr(40,2)=="SB")
                sysByte="05";       
            if (origCode.substr(40,2)=="DA")
                 sysByte = "06";    
            if (origCode.substr(40,2)=="SI")
                sysByte="08";    

            //calculate checksum qr    
            qrByte=this.hexToBytes(origCode.substring(0, origCode.length -4) + sysByte);
            chk=new Uint8Array(1)
            for(j=0;j<qrByte.length; j++)
            {
                chk[0]=chk[0] ^ qrByte[j];
            }
             
            console.log("chk calculated: " + chk[0].toString(16).padStart(2,"0").toUpperCase() + " - chk in string: "+ origCode.substr(42,2).toUpperCase());
            
            if(chk[0].toString(16).padStart(2,"0").toUpperCase()==origCode.substr(42,2).toUpperCase())
            {
                this.productId = origCode.substr(40,2) + "-" + origCode.substr(4,4);
                
                if(origCode.substr(40,2)=='HT')
                {
                    this.productId = "CT-" + origCode.substr(4,4);
                    this.productType="HT";   
                }    

                if (origCode.substr(40, 2) == "SI")
                {
                    this.productLogicaId = origCode.substr(0, 6);
                    this.productId = "SI-" + origCode.substr(6, 4);
                    daysAfter1122=parseInt(origCode.substr(10,4),16);
                    this.productDate= this.getProductDate(daysAfter1122).toLocaleDateString();
                }
                else
                {
                   this.productLogicaId = origCode.substr(0, 4);
                   this.productDate=parseInt(origCode.substr(8,2),16) + "/" + (parseInt(origCode.substr(10,2),16)+"").padStart(2,"0") + "/" + "20"+parseInt(origCode.substr(12,2),16);
                }
               
                this.productIdSw=""+parseInt(origCode.substr(15,3),16);
                this.productRelSw=""+parseInt(origCode.substr(14,1),16);
                this.productBuild=""+parseInt(origCode.substr(18,4),16);
                this.productPlant=""+parseInt(origCode.substr(22,2),16);
                this.qrChk=this.hexToBytes(origCode.substring(42,2));
                
                //add chk su serial number
                var qrSerNum=this.hexToBytes(origCode.substr(24,16));
                var chkSn=new Uint8Array(1)
                for(j=0;j<qrSerNum.length; j++)
                   {
                     chkSn[0]=chkSn[0] ^ qrSerNum[j];
                   }
                this.productSn=""+origCode.substr(24,16) + chkSn[0].toString(16).toUpperCase();
                    
                console.log("new Qr rith SN! Sys:"+ sysByte +" chk:"+ chk[0].toString(16) + " productLogicaId: " +this.productLogicaId +" productDate:",this.productDate," productPlant:",this.productPlant," productIdSw:",this.productIdSw," productRelSw:",this.productRelSw," productBuild:",this.productBuild);
            }
            else
            {
                console.log("CHECKSUM ERROR!!!")
            }
        }

        //------------------- LENGTH == 36 -------------------------------------------------------------------------------------------
        // Si tratta di un nuovo QR CODE con lunghezza = 36 e Serial Number senza header e modalità Data espressa in gg dal 01/01/2022
        //----------------------------------------------------------------------------------------------------------------------------
        if (this.productId != null && this.productId.length == 36) {

            //get all qr code data
            let origCode = ""+this.productId;

            //calculate checksum qr senza tipo di sistema
            qrByte=this.hexToBytes(origCode.substring(0, origCode.length -4));
            chk=new Uint8Array(1)
            for(j=0;j<qrByte.length; j++)
            {
                chk[0]=chk[0] ^ qrByte[j];
            }
            
            console.log("chk calculated: " + chk[0].toString(16).padStart(2,"0").toUpperCase() + " - chk in string: "+ origCode.substr(34,2).toUpperCase());

            if(chk[0].toString(16).padStart(2,"0").toUpperCase()==origCode.substr(34,2).toUpperCase())
            {
                this.productId = origCode.substr(32,2) + "-" + origCode.substr(6,4);
                if(origCode.substr(32,2)=="FM")
                {
                    this.productId = "CT-" + origCode.substr(6,4);
                    this.productType = "FM"
                }
                if(origCode.substr(32,2)=="HT")
                {
                    this.productId = "CT-" + origCode.substr(6,4);
                    this.productType = "HT"
                }
                if(origCode.substr(32,2)=="AC")
                {
                    this.productId = "AC-" + origCode.substr(6,4);
                    this.productType = "AC"
                }
                if(origCode.substr(32,2)=="SD")
                {
                    this.productId = "SD-" + origCode.substr(6,4);
                    this.productType = "AC"
                }
                this.productLogicaId=origCode.substr(0,6);
                daysAfter1122=parseInt(origCode.substr(10,4),16);
                this.productDate= this.getProductDate(daysAfter1122).toLocaleDateString();
                this.productIdSw=""+parseInt(origCode.substr(15,3),16);
                this.productRelSw=""+parseInt(origCode.substr(14,1),16);
                this.productBuild=""+parseInt(origCode.substr(18,4),16);
                this.productPlant=""+parseInt(origCode.substr(22,2),16);
                this.qrChk=this.hexToBytes(origCode.substr(34,2));
                this.progressiveSn=origCode.substr(24,8);
                                    
                console.log("new Qr rith SN! Sys"+ sysByte +" chk:"+ chk[0].toString(16) + " productLogicaId: " +this.productLogicaId +" productDate:",this.productDate," productPlant:",this.productPlant," productIdSw:",this.productIdSw," productRelSw:",this.productRelSw," productBuild:",this.productBuild);
            }
            else
            {
                console.log("CHECKSUM ERROR!!!")
            }
        }

        //------------------- LENGTH == 38 ---------------------------------------------------------------------------------------------------
        //Si tratta di un nuovo QR CODE con lunghezza = 38 per dispositivi di illuminazione DALI e SDB e Data espressa in gg dal 01/01/2022
        //Oppure si tratta di un nuovo QR CODE di centrale con Data espressa in aa/mm/gg
        //------------------------------------------------------------------------------------------------------------------------------------
        if (this.productId != null && this.productId.length == 38) {

            //get all qr code data
            let origCode = ""+this.productId;

            sysByte="00";

            //check tipo di sistema per checksum
            if (origCode.substr(34,2)=="DA")
                sysByte="06";
            if (origCode.substr(34,2)=="SB")
                sysByte = "05";
             if (origCode.substr(34,2)=="00")       //qrcode di centrale
                sysByte="00";

            //calculate checksum qr con tipo di sistema
            qrByte=this.hexToBytes(origCode.substring(0, origCode.length -4) + sysByte);
            chk=new Uint8Array(1)
                
            for(j=0;j<qrByte.length; j++)
            {
                chk[0]=chk[0] ^ qrByte[j];
            }
            
            console.log("chk calculated: " + chk[0].toString(16).padStart(2,"0").toUpperCase() + " - chk in string: "+ origCode.substr(36,2).toUpperCase());

            if(chk[0].toString(16).padStart(2,"0").toUpperCase()==origCode.substr(36,2).toUpperCase())
            {
                if (sysByte == "00")
                {
                    this.productId = origCode.substr(6, 4);

                    if (this.productId == "F001" || this.productId == "F002" || this.productId == "F006" || this.productId == "F007" || this.productId == "F008")
                        this.productLogicaId = origCode.substr(0, 6);
                    else
                        this.productLogicaId = origCode.substr(1, 5);
                    this.productIdSw=""+parseInt(origCode.substr(17,3),16);
                    this.productRelSw=""+parseInt(origCode.substr(16,1),16);
                    this.productBuild=""+parseInt(origCode.substr(20,4),16);
                    this.productDate = (parseInt(origCode.substr(14, 2), 16) + "").padStart(2, "0") + "/" + (parseInt(origCode.substr(12, 2), 16) + "").padStart(2, "0") + "/" + "20" + parseInt(origCode.substr(10, 2), 16);
                }
                else
                {
                    this.productId = origCode.substr(34, 2) + "-" + origCode.substr(4, 4);
                    if(origCode.substr(34,2) =="HT")
                        this.productId = "CT-" + origCode.substr(4, 4);
                    this.productLogicaId=origCode.substr(0,4);
                    daysAfter1122=parseInt(origCode.substr(8,4),16);
                    this.productDate = this.getProductDate(daysAfter1122).toLocaleDateString();
                    this.productGTIN=""+parseInt(origCode.substr(12,12),16);
                }
               
                this.productPlant=""+parseInt(origCode.substr(24,2),16);
                this.qrChk=this.hexToBytes(origCode.substr(36,2));
                this.progressiveSn=origCode.substr(26,8);
                                    
                console.log("Lighting DALI o SDBT\n");
                console.log("CloudCode: " + this.productId + "\n");
                console.log("productLogicaId: " +this.productLogicaId + "\n");
                console.log("productDate: " +this.productDate + "\n");
                console.log("productPlant: " +this.productPlant + "\n");
                console.log("product Dali GTIN: " +this.productGTIN + "\n");
                console.log("progressive SN: " +this.progressiveSn + "\n");
                console.log("chk: " + chk[0].toString(16));
            }
            else
            {
                console.log("CHECKSUM ERROR!!!")
            }
        }

        if (this.currentProduct == null) {
             this.$store.dispatch('loadProductInfo', this.productId);
        }
     }
}

</script>